import styled from 'styled-components'
import Flex from 'components/Flex'
import { Spin } from 'antd'

export const ShortListModalImg = styled.div`
  text-align: center;
  margin-bottom: 25px;
`
export const ModalText = styled.div`
  color: #010e30;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 25px;
`
export const ButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
`
export const StyledSpin = styled(Spin)`
  .ant-spin-dot-item {
    background-color: #5db594;
  }
`

export const StyledDivision = styled.div`
  padding-top: 12px;
  text-align: center;
  line-height: 1.5;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 11px;
`
export const EventName = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4;
  text-align: left;
`
export const MainDiv = styled.div`
  width: 93%;
  border: #d8ddff 2px solid;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: ${({ className }) => {
    switch (className) {
      case 'primary':
        return '#B6BDFF40'
      case 'secondary':
        return '#FFB6C140'
      case 'tertiary':
        return '#C1FFC140'
      default:
        return '#B6BDFF40'
    }
  }};
  border-color: ${({ className }) => {
    switch (className) {
      case 'primary':
        return '#d8ddff'
      case 'secondary':
        return '#ffb6c1'
      case 'tertiary':
        return '#c1ffc1'
      default:
        return '#d8ddff'
    }
  }};
  margin-left: 21px;
  margin-top: 25px;
  margin-bottom: 20px;
  margin-right: 21px;
`
export const StudentDiv = styled.div`
  font-size: 20px;
  padding-top: 30px;
`
export const EventLabel = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  padding-bottom: 12px;
`
export const EventLabel1 = styled.div`
  margin-top: 4px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
`

export const EventData = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;

  a {
    color: blue;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`
export const EventData1 = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
`

export const Category = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 400;
  padding-bottom: 20px;
`

export const EventDatecard = styled.div`
  width: 271px;
  height: 58px;
  border-radius: 47px;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: ${({ className }) => {
    switch (className) {
      case 'primary':
        return '#B5A3F7'
      case 'secondary':
        return '#FFB6C140'
      case 'tertiary':
        return '#72B06F'
      default:
        return '#B6BDFF40'
    }
  }};
`
export const StyledButton = styled.button`
  width: 86px;
  height: 31px;
  border-radius: 22.5px;
  background-color: #007bff; /* Example background color */
  color: #fff; /* Example text color */
  border: none;
  cursor: pointer;
`
export const VerticalDivider = styled.div`
  height: 28px;
  border-left: 1.3px solid #007bff;
`
export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`
export const StyledButton1 = styled.button`
  width: 86px;
  height: 31px;
  border-radius: 22.5px;
  color: #fff;
  border: none;
  cursor: pointer;
  color: black;
  border: 1px solid #007bff;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
`

export const Right = styled(Flex)`
  justify-content: flex-end;
  padding-right: 19px;
  padding-bottom: 20px;
  margin-top: -20px;
`
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 500px;
  max-width: 100%;
`

export const ModalCheckbox = styled.div`
text-align: center;
gap: 10px;
position: relative;
margin-top: -22px;
padding: 10px;
font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
  color: #A5A5A5;

}
`
